import {APP_PREFIX_PATH} from "../AppConfig";
import React from "react";

export const processes = [
    {
        key: "processes",
        path: `${APP_PREFIX_PATH}/processes`,
        component: React.lazy(() => import("views/app-views/processes")),
        meta: {
            permission: "LIST_PROCESSES"
        }
    },

    {
        key: "processes-yearly-config",
        path: `${APP_PREFIX_PATH}/processes-yearly-config`,
        component: React.lazy(() => import("views/app-views/processes/yearlyConfig")),
        meta: {
            permission: "YEARLY_CONFIG_INDICATORS"
        }
    },

    {
        key: "realisations",
        path: `${APP_PREFIX_PATH}/realisations`,
        component: React.lazy(() => import("views/app-views/realisations")),
        meta: {
            permission: "LIST_REALISATIONS"
        }
    },

    {
        key: "store-indicators-realisations",
        path: `${APP_PREFIX_PATH}/store-indicators-realisations`,
        component: React.lazy(() => import("views/app-views/realisations/storeRealisations")),
        meta: {
            permission: "ADD_REALISATIONS"
        }
    },
]



